
import Styles from './card.css';
import React from 'react';
import { animated } from 'react-spring';
import {
  faCalendarAlt,
  faClock,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertUTCDateToLocalDateStringFormat, covertUTCDateTimeToLocalTimeStringFormat } from '../../utilities/DateTimeToLocalDateTime';

export const Card = ({ item }) => {
  const imageURL = (item.imageURL != null && item.imageURL != '') ? item.imageURL 
  : "./defaultEvent2.jpg";

  return (
    <animated.div
      key={item.id}
      className={'slider-item' }
    >
      <div className='event-image'>
        <img src={imageURL} alt='Event' />
      </div>
      <div className='event-details'>
        <h3 className='event-title mb-3'>
          {item.title}
        </h3>
        <p className='event-date'>
          <FontAwesomeIcon icon={faCalendarAlt} className='icon text-black' /> 
          <b>Date:</b> {convertUTCDateToLocalDateStringFormat(item.date, false, 'LL')}
        </p>
        <p className='event-time'>
          <FontAwesomeIcon icon={faClock} className='icon text-black' /> 
        <b>  Time:</b> {covertUTCDateTimeToLocalTimeStringFormat(item.date)}
        </p>
        <p className='event-speaker'>
          <FontAwesomeIcon icon={faUser} className='icon text-black' /> 
          <b>Speaker:</b> {item.speakerName}
        </p>
      </div>
    </animated.div>
  );
};